import { SimCardAlert } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { computed, makeObservable } from 'mobx';
import ReactComponent from './ReactComponent';
import { inject, observer } from 'mobx-react';

class IconeSemInformacaoIntimacao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            semInformacaoIntimacao: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get semInformacaoIntimacao() {
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[this.registro.processo.numeroCompleto];
            if (partesProcesso && partesProcesso.partes) {
                return partesProcesso.partes.findIndex((parte) => parte.semInformacaoIntimacao) !== -1;
            }
        }
        return false;
    }

    render() {
        if (!this.registro) {
            return null;
        }

        if (this.semInformacaoIntimacao) {
            return (
                <Tooltip title={<Typography>Sem informação para intimar todas as partes</Typography>}>
                    <SimCardAlert sx={{ fillOpacity: 0.7, cursor: 'default', color: 'darkorange' }} />
                </Tooltip>
            );
        }

        return null;
    }
}

export default inject('stores')(observer(IconeSemInformacaoIntimacao));
